import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import { useSelector, useDispatch } from 'react-redux';
import LinearProgress from '@mui/material/LinearProgress';
import Button from '@mui/material/Button';
import { useNavigate } from "react-router-dom";
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { ChangeSTOrderState, addOrUpdateItem, resetSTOrderResultBox, setSTOrderDateMustDelivered, setSTOrderDescription, setSTOrderMatrixRenderOff, setSTOrderPayType, setSTPreviewItemsDialogClose, setSTPreviewItemsFilter, submitOrderPayment, submitSTOrder, testThe } from '../slices/storder.slice';
import uuid from 'react-uuid';
import Alert from '@mui/material/Alert';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import CancelIcon from '@mui/icons-material/Cancel';
import Tooltip from '@mui/material/Tooltip';
import DataGrid from 'react-data-grid';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CheckIcon from '@mui/icons-material/Check';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import TextField from '@mui/material/TextField';
import DatePicker from "react-multi-date-picker";
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { addComma, removeComma, separateNumber } from '../helpers/mmg';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { textAlign } from '@mui/system';
import Divider from '@mui/material/Divider';
import productbrand from '../assets/images/productbrand.png'
import historyicon from '../assets/images/historyicon.png'
import moneyicon from '../assets/images/moneyicon.png'
import PrintIcon from '@mui/icons-material/Print';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment } from '@mui/material';
import { getReportURL } from '../api';
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));


export const zeroPad = (num, places) => String(num).padStart(places, '0');


const mdTheme = createTheme({

  typography: {
    fontFamily: [
      "mohammadfont",
      "Tahoma",
      "Verdana"
    ].join(",")
  },
  
  direction: 'ltr',
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#FBC02D',
          color: '#424242'
        },
      },
    },
  }
});


export const STPreviewItems = () => {
  

  const [open, setOpen] = React.useState(false);
  const [openApprove, setOpenApprove] = React.useState(false);
  const [openDeny, setOpenDeny] = React.useState(false);

  const handleYes = () => {
    setOpen(false);
    dispatch(submitSTOrder({ stOrder : stOrder , authUser}));
    //dispatch(testThe({ authUser}));
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleNo = () => {
    setOpen(false);
  };
  

  const dispatch = useDispatch();
  //const { user: authUser } = useSelector(x => x.auth);
  const authUser = JSON.parse(localStorage.getItem('user'));

  const stOrder = useSelector(x => x.stOrder);
  //const matrix = useSelector(x => x.matrix.itemsToAddFromMatrix);
  const defaultValues1 = useSelector(x => x.defaultValue);
  const defaultValues = JSON.parse(localStorage.getItem('defaultValue'));

  let navigate = useNavigate();

  const summaryRows = [{
    id: 'total_0',
    totalQuantity: stOrder.previewItems.reduce((n, r ) => n + (r.Quantity), 0),
    totalProvidedQuantity: stOrder.previewItems.reduce((n, r ) => n + (r.ProvidedQuantity), 0)

  }];
  const columns = [
    {
      name: 'ردیف',
      key: 'RowNumber',
      width: '2%',
      summaryFormatter({ row: { totalQuantity } }) {
        return <span>جمع</span>
      }
    }, 
    {
      key: 'ProductTitle',
      name: ' محصول',
      width: '22%',
      resizable: true,
      sortable: true,
    },
    {
      key: 'ProductCode',
      name: 'کد محصول ',
      width: '10%',
      resizable: true,
      sortable: true,
    },
    {
      key: 'Quantity',
      name: 'تعداد',
      width: '6%',
      resizable: true,
      sortable: true,
      formatter(props) {
        return <span>{addComma(props.row.Quantity.toString())}</span>
      },
      summaryFormatter({ row: { totalQuantity } }) {
        return <span>{totalQuantity}</span>
      }
    },
    {
      key: 'ProvidedQuantity',
      name: 'تامین شده',
      width: '6%',
      resizable: true,
      sortable: true,
      formatter(props) {
        return <span>{addComma(props.row.ProvidedQuantity.toString())}&nbsp;&nbsp;<Brightness1Icon fontSize="small" className={props.row.ProvidedQuantity === props.row.Quantity ? 'FullyProvided' : (props.row.ProvidedQuantity < props.row.Quantity &&  props.row.ProvidedQuantity > 0 ?  'PartiallyProvided' : 'FullyNotProvided')} /></span>
      },
      summaryFormatter({ row: { totalProvidedQuantity } }) {
        return <span>{totalProvidedQuantity}</span>
      }
    },
    {
      key: 'Fee',
      name: 'فی',
      width: '8%',
      resizable: true,
      sortable: true,
      formatter(props) {
        return <span>{addComma(props.row.Fee.toString())}</span>
      }
    },
    {
      key: 'Discount',
      name: 'تخفیف',
      width: '7%',
      resizable: true,
      sortable: true,
      formatter(props) {
        return <span>{authUser.role === "CustomerPortal" || authUser.role === "Personnel" ? addComma(props.row.Discount.toString()) : ''}</span>
      }
    },
    {
      key: 'Price',
      name: 'قیمت',
      width: '7%',
      resizable: true,
      sortable: true,
      formatter(props) {
            return <span>{addComma(props.row.Price.toString())}</span>
      }
    },
    {
      key: 'CorrespondingLeftRowNmber',
      name: 'ردیف معادل چپ',
      width: '8%',
      resizable: true,
      sortable: true
    },
    {
      key: 'Consumer',
      name: 'مصرف کننده',
      width: '7%',
      resizable: true,
      sortable: true
    },
    {
      key: 'Optician',
      name: 'عینک ساز',
      type: 'number',
      width: '9%',
      resizable: true,
      sortable: true
    },
    {
      key: 'ProvidedQuantity',
      name: 'پرینت گارانتی',
      width: '5%',
      resizable: true,
      sortable: true,
      formatter(props) {
        return <Button variant="contained" onClick={(e) => handlePrintClick(e, props, props.row.OrderItemID)} startIcon={<PrintIcon />}> پرینت</Button>
      }
    }
  ];

  const stateHistoryCols = [
    {
      name: 'ردیف',
      key: 'RowId'
    }, 
    {
      key: 'SrcState',
      name: ' وضعیت مبدا',
      width: '15%'
    },
    {
      key: 'DstState',
      name: ' وضعیت مقصد',
      width: '15%'
    },
    {
      key: 'Description',
      name: ' شرح ',
      width: '30%'
    },
    {
      key: 'UserChanger',
      name: ' انجام دهنده ',
      width: '15%'
    },
    {
      key: 'StateDateTime',
      name: ' تاریخ و ساعت  ',
      width: '15%',
      formatter(props) {
        return <span style={{direction : 'rtl'}}>{props.row.StateDateTime.toString()}</span>
      }
    }
  ];
  
  const handlePrintClick = (e , props, OrderItemId) =>{
  
    console.log(process.env.REACT_APP_REPORT_URL);
    var baseAdsress = getReportURL();//process.env.REACT_APP_REPORT_URL;//'http://80.210.21.25:81';
    var reportName = 'WarrantyLR_Ready_4';
    var up = authUser.username+'$'+encodeURIComponent(authUser.password);
    var ul = baseAdsress+"/Home/PDFReportPage2?reportname="+reportName+"&SelectedValue="+OrderItemId+"&hash="+up
    console.log("URL id");
    console.log(ul);
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.href = ul;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  }

  const onPrintClicked = (e) =>{

    console.log(process.env.REACT_APP_REPORT_URL);
    var baseAdsress = getReportURL();//process.env.REACT_APP_REPORT_URL;//'http://80.210.21.25:81';
    var reportName = 'STOrder';
    var up = authUser.username+'$'+encodeURIComponent(authUser.password);
    var ul = baseAdsress+"/Home/PDFReportPage2?reportname="+reportName+"&SelectedValue="+stOrder.selectedSTOrderId+"&hash="+up
    console.log("URL id");
    console.log(ul);
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.href = ul;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  

  let dataSource  = [];
  //console.log(invoices.selectedInvoice);
  if(stOrder.previewItems != undefined && stOrder.previewItems !== undefined && stOrder.previewItems.length > 0)
  {
      dataSource = stOrder.previewItemsBackup;//.map((item, i) => ({...item, rowIndex : i+1}));
      //dataSource = stOrder.items.map((item, i) => ({...item, rowIndex : i+1}));
  }
 
  let dataSourceForStateHistory  = [];
  //console.log(invoices.selectedInvoice);
  if(stOrder.OrderHistory != undefined && stOrder.OrderHistory !== undefined && stOrder.OrderHistory.length > 0)
  {
      dataSourceForStateHistory = stOrder.OrderHistory;//.map((item, i) => ({...item, rowIndex : i+1}));
  }

  const handleDenyOrder = (e) =>{
    setOpenDeny(true);
  }
  const handleApproveOrder = (e) =>{
    setOpenApprove(true);
  }
  const handleYesDeny = (e) =>{
    setOpenDeny(false);
    dispatch(ChangeSTOrderState({ newState : "رد_شده", stOrder : stOrder , authUser}));
  }
  const handleNoDeny = (e) =>{
    setOpenDeny(false);
  }
  
  const handleYesApprove = (e) =>{
    setOpenApprove(false);
    dispatch(ChangeSTOrderState({ newState : "در_صف_تامین", stOrder : stOrder , authUser}));
  }
  const handleNoApprove = (e) =>{
    setOpenApprove(false);
  }
 
//reportName=WarrantyLR_Ready_2&oid=8732513

const filterInPreview =(e) =>{
  console.log("E");
  console.log(e.target.value);
  if(e.target.value === "")
  {
    if(stOrder.previewItems != undefined && stOrder.previewItems !== undefined && stOrder.previewItems.length > 0)
    {
        dispatch(setSTPreviewItemsFilter(stOrder.previewItems));
    }
  }else{

    dispatch(setSTPreviewItemsFilter(dataSource.filter(x => x.ProductTitle.toLowerCase().includes(e.target.value.toLowerCase()) ||  x.ProductCode.toLowerCase().includes(e.target.value.toLowerCase()))));
    console.log(dataSource);
  }
}

const handleClosePreviewDialog = (e) =>{

  dispatch(setSTPreviewItemsDialogClose());

}
const handleCloseMessageBox = () =>{
  dispatch(resetSTOrderResultBox());
  navigate(0);
  //navigate('/MyWaitingOrders');
        

}
const handleSubmitFinalOrder = (e) =>{
  dispatch(setSTOrderPayType(1));
  setOpen(true);
}
const handleSubmitFinalOrderOnlinePayment = (e) =>{
  dispatch(setSTOrderPayType(2));
  setOpen(true);
}

const handleOrderPayment = (e) =>{
  
  dispatch(submitOrderPayment({ stOrder : stOrder , authUser}));

}

const handleDescriptionChange = (e) =>{

  dispatch(setSTOrderDescription(e.target.value));

}
const onDateMustDeliveredSelectedHandler = (e) =>{

  var day = zeroPad(e.day , 2);
  var month = zeroPad(e.month.number , 2);
  var year = e.year;

  dispatch(setSTOrderDateMustDelivered(year + "/" + month + "/"+ day));
  
}
function rowKeyGetter(row) {
  return row.RowId;
}

function rowKeyGetterStateHistory(row) {
  return 'His' + row.RowId.toString();
}
function EmptyRowsRenderer() {
  return (
  
    <div style={{ textAlign: 'center', gridColumn: '1/-1' }}>
      {stOrder.loading ? '' :   ' اطلاعاتی برای نمایش وجود ندارد' }
    </div>
  );
}


return (

<ThemeProvider theme={mdTheme}>
  <div>
      <Dialog
        //fullScreen
        sx={{
          "& .MuiDialog-container": {
             alignItems: "flex-start",
          },
       }}
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "1400px !important",
            mt: "50px"
          },
        }}
        open={stOrder.previewItemsDialog}
        //onClose={handleClosePreviewDialog}
        //TransitionComponent={Transition}
        >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1 }} component="div">
            پیش نمایش سفارش  &nbsp; {stOrder.number}
            &nbsp;&nbsp;&nbsp;&nbsp;   
              <Tooltip arrow followCursor title="پرینت سفارش">
                <IconButton onClick={onPrintClicked}>
                            <PrintIcon sx={{ color: '#000000' }}/>
                          </IconButton>
              </Tooltip>
            </Typography>


            <Button autoFocus color="inherit" onClick={handleClosePreviewDialog}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
         
            </Button>
          </Toolbar>
       
        </AppBar>
        <br/>
        <Grid container 
                    spacing={{ xs: 1, md: 1 }} 
                    columns={{ xs: 4, sm: 8, md: 12 }}
                    direction={{ xs: 'column', sm : 'row-reverse' , md: 'row-reverse' , lg : 'row-reverse'}}
                    >
                      

        <Grid item xs={6} sm={6} md={6} lg={6} key={390012} >
        <Box sx={{ flexGrow: 1 }} textAlign='left'>
         <span>توضیحات:{stOrder.description}</span>
        </Box>
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} key={3900} >
                          <Box sx={{ flexGrow: 1 }} textAlign='left'>
        <TextField
          id="input-with-icon-textfield"
          label="جستجو"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          variant="standard"
          onChange={filterInPreview} 
        />
        </Box>
        </Grid>
        </Grid>

        <DataGrid 
        renderers={{ noRowsFallback: <EmptyRowsRenderer /> }}
        direction="rtl" 
        columns={columns} 
        rows={dataSource} 
        rowKeyGetter={rowKeyGetter}
        bottomSummaryRows={summaryRows}
        //style={{height : dynamicHeight}}
        />


<Grid container 
                    spacing={{ xs: 1, md: 1 }} 
                    columns={{ xs: 4, sm: 8, md: 12 }}
                    direction={{ xs: 'column', sm : 'row-reverse' , md: 'row-reverse' , lg : 'row-reverse'}}
                    >
                      
                          <Grid item xs={12} sm={12} md={12} lg={12} key={390} >
                          <Box sx={{ flexGrow: 1 }} textAlign='left'>
                       
<table style={{width : '250px'}}>
  <tr>
  <td className='tdTableRowForOrderPreviewPriceRight'>مبلغ کل </td>
  <td className='tdTableRowForOrderPreviewPriceLeft'>{addComma(stOrder.previewItems.reduce((n, r ) => n + (r.Quantity * r.Fee), 0).toString())}</td>
  </tr>
  {authUser.role === "CustomerPortal" || authUser.role === "Personnel" || authUser.role === "FinancialPersonnel" ? 
  <tr >
  <td className='tdTableRowForOrderPreviewPriceRight'>تخفیف کل</td>
  <td className='tdTableRowForOrderPreviewPriceLeft'>{addComma(stOrder.previewItems.reduce((n, {Discount}) => n + Discount, 0).toString())}</td>
    </tr>
: ""}
    <tr >
    <td className='tdTableRowForOrderPreviewPriceRight'>قابل پرداخت</td>
  <td className='tdTableRowForOrderPreviewPriceLeft'>{addComma(stOrder.previewItems.reduce((n, {Price}) => n + Price, 0).toString())}</td>
    </tr>
</table>
</Box>
</Grid>
</Grid>


{stOrder.OrderHistory != undefined && stOrder.OrderHistory !== undefined && stOrder.OrderHistory.length > 0 ?
<Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{ bgcolor: '#bbdefb'}}
          >
            <Typography sx={{ width: '33%', flexShrink: 0 }}>
            <img src={historyicon} style={{float: 'right'}}/>&nbsp;&nbsp;تاریخچه سفارش </Typography>
         
        </AccordionSummary>
        <AccordionDetails>
        <DataGrid 
        fullWidth
        renderers={{ noRowsFallback: <EmptyRowsRenderer /> }}
        direction="rtl" 
        columns={stateHistoryCols} 
        rows={dataSourceForStateHistory} 
        rowKeyGetter={rowKeyGetterStateHistory}
        //style={{height : dynamicHeight}}
        />
        </AccordionDetails>
      </Accordion>
      :""}

{stOrder.readOnly ? "" : 
<span>
<span>
  <Tooltip title="ثبت سفارش">

<Button color="success" className='mmgBtnSubmit' disabled={stOrder.items <= 0} onClick={handleSubmitFinalOrder} variant="outlined" startIcon={<BeenhereIcon />}>
ثبت نهایی سفارش
</Button>

</Tooltip>
{authUser.username === "naghdi" ?
<span>
<span>
<Tooltip title="ثبت سفارش و پرداخت">
<Button color="success" className='mmgBtnSubmit' disabled={stOrder.items <= 0} onClick={handleSubmitFinalOrder} variant="outlined" startIcon={<BeenhereIcon />}>
ثبت سفارش و پرداخت
</Button>
</Tooltip> 
</span>
<span>
  {stOrder.orderState === "در_انتظار_پرداخت"? 
  <Tooltip title="پرداخت سفارش">

  <Button color="success" className='mmgBtnSubmit' disabled={stOrder.items <= 0} onClick={handleOrderPayment} variant="outlined" startIcon={<BeenhereIcon />}>
 پرداخت سفارش
  </Button>
  
  </Tooltip>
  : ""}
</span>
</span>: ""
}
</span>

<span>
  {stOrder.orderState === "در_انتظار_پرداخت"? 
  <Tooltip title="پرداخت سفارش">

  <Button color="success" className='mmgBtnSubmit' disabled={stOrder.items <= 0} onClick={handleOrderPayment} variant="outlined" startIcon={<BeenhereIcon />}>
 پرداخت سفارش
  </Button>
  
  </Tooltip>
  : ""}
</span>
</span>
}


{stOrder.orderState === "در_انتظار" && ( authUser.role === "CustomerPortal" || authUser.role === "FinancialPersonnel" ) ? 
<Box sx={{ flexGrow: 1 }} textAlign='center'>
     
     <Grid container>
              <Grid item xs={12}>
                      <Tooltip title="تایید سفارش">

                      <Button color="success" className='mmgBtnSubmit'
 disabled={stOrder.loading}
onClick={handleApproveOrder} variant="outlined" startIcon={<BeenhereIcon />}>
تایید سفارش
</Button>

</Tooltip>

<Tooltip title="رد سفارش">

<Button color="error" className='mmgBtnSubmit'
disabled={stOrder.loading}
onClick={handleDenyOrder} variant="outlined" startIcon={<CloseIcon />}>
رد سفارش
</Button>

</Tooltip> </Grid></Grid></Box> : ""
}

          {stOrder.loading ?   <div className="LoadingDiv">در حال تبادل اطلاعات <LinearProgress color="inherit" /></div>: "" }
              <Dialog
              open={open}
              //onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"تایید "}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                 آیا از ثبت نهایی سفارش اطمینان دارید؟
                </DialogContentText>
              </DialogContent>
              <DialogActions>
              <Button variant="contained" color='success' startIcon={<CheckIcon />} onClick={handleYes}>
                بله
              </Button>
              <Button variant="contained" color='error' startIcon={<CancelIcon/>} onClick={handleNo}>
                خیر
              </Button>
            

              </DialogActions>
            </Dialog>

            <Dialog
              open={openDeny}
              //onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"تایید "}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                 آیا از رد سفارش اطمینان دارید؟
                </DialogContentText>
              </DialogContent>
              <DialogActions>
              <Button variant="contained" color='success' startIcon={<CheckIcon />} onClick={handleYesDeny}>
                بله
              </Button>
              <Button variant="contained" color='error' startIcon={<CancelIcon/>} onClick={handleNoDeny}>
                خیر
              </Button>           
              </DialogActions>
            </Dialog>


            <Dialog
              open={openApprove}
              //onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"تایید "}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                 آیا از تایید نهایی سفارش اطمینان دارید؟
                </DialogContentText>
              </DialogContent>
              <DialogActions>
              <Button variant="contained" color='success' startIcon={<CheckIcon />} onClick={handleYesApprove}>
                بله
              </Button>
              <Button variant="contained" color='error' startIcon={<CancelIcon/>} onClick={handleNoApprove}>
                خیر
              </Button>
            

              </DialogActions>
            </Dialog>


      
      </Dialog>
      </div>

      <Dialog
              open={stOrder.boxType > 0}
              //onClose={handleCloseMessageBox}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
             >
              <DialogTitle id="alert-dialog-title">
                {"نتیجه عملیات"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                <Alert severity={stOrder.boxType === 1 ? "error" : (stOrder.boxType === 2 ? "success" : "info")}>
                <Typography
                    variant="span"
                    color="primary"
                    dangerouslySetInnerHTML={{ __html: stOrder.boxMessage }}>
                    
                </Typography>
             
                  </Alert>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
               <Button variant="contained" color='error' onClick={handleCloseMessageBox}>
                     خب
              </Button>
              </DialogActions>
            </Dialog>



    </ThemeProvider>

  );
}

export default STPreviewItems;